import { forwardRef, type ReactNode, useEffect } from 'react';

import { legacyTheme, styled } from '@prose-ui/legacy';

import { ModuleHeroContent } from './ModuleHeroContent';

const Root = styled.header<{ img: string }>`
  position: relative;
  top: 0;
  left: 0;
  z-index: 100;

  width: 100vw;
  height: calc(100vh - 95px);
  padding: 32px 24px;

  background-image: ${({ img }) => `url(${img})`};
  background-position: top;
  background-repeat: no-repeat;
  background-size: cover;

  box-shadow: 0 4px 8px rgb(0 0 0 / 30%);

  ${legacyTheme.breakpoints.up('sm')} {
    padding: 64px 72px;
    background-position: right;
  }

  ${legacyTheme.breakpoints.up('md')} {
    padding: 8vh 135px;

    @media (min-height: 850px) {
      padding: 14vh 135px;
    }
  }
`;

type ModuleHeroImageProps = {
  bgLoaded: () => void;
  content: {
    title: string | ReactNode;
    paragraphMobile: ReactNode;
    paragraphDesktop: ReactNode;
  };
  showArrow?: boolean;
  testId: string;
  textColor: string;
  url: string;
};

export const ModuleHeroImage = forwardRef<HTMLDivElement, ModuleHeroImageProps>(
  ({ url, textColor, bgLoaded, showArrow = false, testId, content }, ref) => {
    const img = new Image();

    useEffect(() => {
      /**
       * Trick to improve the visual loading of the page
       * We wait for the image of the first module to load
       * before displaying the page
       * and also before setting the seconde module position
       * which can cause an overlapping jerky effect
       */
      img.src = `${url}`;
      img.onload = () => {
        bgLoaded();
      };
      // @ts-expect-error TODO: it's better to refactor this page to use Image then try to investigate and fix this
      if (img.complete) img.onload();
    }, [img.complete]);

    return (
      <Root ref={ref} data-testid={testId} img={url}>
        <ModuleHeroContent content={content} showArrow={showArrow} textColor={textColor} />
      </Root>
    );
  },
);

ModuleHeroImage.displayName = 'ModuleHeroImage';
